//
// Copyright (c) 2011-2021 by Curalate, Inc.
//

import IItemMetadata from '@models/IItemMetadata';

export function hasBVImportLabel(itemMetadata: IItemMetadata): boolean {
  return itemMetadata.reelTags.includes('bazaarVoice-import');
}

/**
 *
 * All cases within `RightsCreationSource` are valid `hasRights` sources
 *
 * @param {IItemMetadata} itemMetadata
 * @returns {boolean}
 */
export function hasRightsByCreationSource(
  itemMetadata: IItemMetadata,
): boolean {
  return !!itemMetadata.rightsPermissions?.creationSource;
}
